export const STORAGE_KEYS = {
  billingInfo: "billingInfo",
  billingHash: "billingHash",
  billingCounter: "billingCounter",
  fingerprint: "fingerprint",
  firstClickURL: "firstClickURL",
  saleURL: "saleURL",
};
